// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3l8Oi","col":"styles_col__3tjLT"};